import { render, staticRenderFns } from "./UserPurchases.vue?vue&type=template&id=0b0d3343&scoped=true&"
import script from "./UserPurchases.vue?vue&type=script&lang=js&"
export * from "./UserPurchases.vue?vue&type=script&lang=js&"
import style0 from "./UserPurchases.vue?vue&type=style&index=0&id=0b0d3343&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d3343",
  null
  
)

export default component.exports